import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { genId } from "../../core/services/genId";
import { Group, GroupStub } from "../models/group.model";
import { Observable } from "rxjs";

export interface GroupSearchSpec {
    id?: string;
    stubs?: boolean;
    internal?: boolean;
    contains?: string;
    fullContactDetails?: boolean;
}
@Injectable()
export class GroupService {
    public readonly BaseUrl = '/api/admin/groups';

    constructor(
        public readonly http: HttpClient
    ) {
    }

    get(spec: GroupSearchSpec): Observable<Group | Group[] | GroupStub[]> {
        if (spec.id !== undefined) {
            return this.http.get<Group>(`${this.BaseUrl}/${spec.id}`);
        }
        else {
            let params = this.buildHttpParams(spec);
            return this.http.get<GroupStub[]>("/api/admin/groups", { params: params });
        }
    }

    getGroupById(id: string): Observable<Group> {
        return this.http.get<Group>(`/api/admin/groups/${id}`);
    }

    save(group: Group): Observable<any> {
        if (group.id === null || group.id.match(/^\s+$/)) {
            group.id = genId();
        }
        return this.http.post<Group>(`/api/admin/groups/${group.id}`, group);
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${this.BaseUrl}/${id}`)
    }

    public buildHttpParams(spec: GroupSearchSpec): HttpParams {
        spec = spec || {};
        let params = new HttpParams();

        Object.getOwnPropertyNames(spec).forEach((value, index, array) => {
            params = params.append(value, spec[value]);
        });

        return params;
    }
}